<template>
    <div class="d-flex justify-content-between mt-4">
        <button v-if="showEditBtn" class="btn tertiary flex-all fs-smaller" @click="openEditEvent">
          Edit
        </button>
        <button v-if="showReservationsBtn" class="btn tertiary flex-all mx-1 fs-smaller" @click="routeTo('reservationsEvent')">
          Reservations
        </button>
        <button class="btn bg-color-6 lightest tertiary flex-all fs-smaller" @click="showCanceledPopup" v-if="showCanceledBtn">
            Canceled
        </button>
        <button v-if="showBookingBtn" class="btn flex-all fs-smaller" :class="bookButtonLook.classes" @click="bookButtonPress">
          {{bookButtonLook.label}}
        </button>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { eventMixin } from '@/mixins/event'

    export default {
        props: {
            event: Object
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
            ]),
            showEditBtn: function () {
                return this.accessPermissionFilter(['admin', 'supervisor'])
            },
            showReservationsBtn: function () {
                // hide to viewer
                return (this.canISellThisEvent(this.event) || this.accessPermissionFilter(['admin'])) && !this.accessPermissionFilter(['viewer'])
            },
            showCanceledBtn: function () {
                // Admin never sees the canceled btn
                if (this.accessPermissionFilter(['admin'])) {
                    return false
                }

                return this.event.status == -1
            },
            showBookingBtn: function () {
                // if viewer
                if(this.accessPermissionFilter(['viewer', 'mainSupervisor'])){
                    return false
                }

                // if the event is shareType 2 (virtual rooster) and is closed
                if(this.event.shareType == 2 && this.event.status == -2){
                    return false
                }

                // if is admin
                if(this.accessPermissionFilter(['admin'])){
                    return true
                }

                // if user can sell
                return this.canISellThisEvent(this.event)

            },
            bookButtonLook: function () {
                let btnOpacity = (this.event.quantityAvailable < 1 && this.event.availabilityType != 1)? 'opacity-50' : '';

                if(this.canISellThisEvent(this.event)){
                    return {
                        label: 'BOOK',
                        classes: btnOpacity + ' '
                    }
                } else {
                    return {
                        label: 'CLOSED',
                        classes: btnOpacity + ' bg-dark'
                    }
                }
            }
        },
        mixins: [
            eventMixin
        ],
        methods: {
            ...mapActions([
                'resetClonedReservation',
                'updateClonedReservation',
                'openModal',
                'setReservationSelectedEvent',
                'setReservationSelectedProduct',
                'setAsNotCreatingSingleEvent',
                'setSelectedEventListReservations'
            ]),
            routeTo: function(route) {
                // this.$router.push({ name: route, params: {eventId : this.event.id} });
                this.setSelectedEventListReservations(this.event)
                this.$router.push({ name: route });
            },
            bookButtonPress: function () {
                // If admin and event is canceled (admin can see the book button even if the event is canceled)
                if(this.event.status == -1){
                    this.$dialog.alert('Be aware, this event "'+this.event.product.name+'" has been canceled. You can only see the "Book" button because your are an Administrator.<br>' + (this.event.statusMessage? 'Cancel message: '+this.event.statusMessage : ''), {okText: 'OK'})
                    .then(() => {
                        this.addReservation()
                    })
                    .catch(() => {
                        this.addReservation()
                    });
                } else {
                    this.addReservation()
                }

            },
            addReservation: function() {

                if(this.event.quantityAvailable > 0 || this.event.availabilityType == 1){
                    this.setReservationSelectedEvent(this.event);
                    this.setReservationSelectedProduct(this.event.product);
                    this.$router.push('/reservation/resume');
                } else {
                    this.$toasted.info('Event fully booked')
                }
            },
            openEditEvent: function() {
                this.setAsNotCreatingSingleEvent()
                this.openModal('EventEdit');
            },
            showCanceledPopup: function() {
                this.$dialog.alert('The event "'+this.event.product.name+'" has been canceled.<br>' + (this.event.statusMessage? 'Cancel message: '+this.event.statusMessage : ''), {okText: 'OK'})
                .then(function () {

                })
                .catch(function () {
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Links.vue?464e051e